import { FC, PropsWithChildren } from "react";
import { Box, makeStyles, Theme } from "@material-ui/core";
import { UserProfile } from "@welldigital/ui-common/Authentication/components/UserProfile";
import { getUserProfileProps } from "../../app/config";
import WellLogo from "../../assets/WellGreen.svg";

const useStyles = makeStyles((theme: Theme) => ({
  logoContainer: {
    display: "flex",
    flexDirection: "column",
    height: 75,
    justifyContent: "center",
  },
  textContainer: {
    marginLeft: theme.spacing(2),
  },
  wellLogo: {
    height: "50px",
    objectFit: "contain",
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
}));

type PageLayoutProps = { withUserProfile?: boolean; children: JSX.Element };
const PageLayout: FC<PropsWithChildren<PageLayoutProps>> = ({
  children,
  withUserProfile,
}) => {
  const userProfileProps = getUserProfileProps();
  const classes = useStyles();
  return (
    <Box pt={1} px={1} pb={2} minWidth={310}>
      <Box display={"flex"} justifyContent={"center"}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          width={{ xs: "100%", md: 900 }}
        >
          <div className={classes.logoContainer}>
            <a href={"https://www.well.co.uk/"}>
              <img
                src={WellLogo}
                alt={"WellLogo"}
                className={classes.wellLogo}
              />
            </a>
          </div>
          {withUserProfile && <UserProfile {...userProfileProps} />}
        </Box>
      </Box>
      <hr />
      <Box display={"flex"} justifyContent={"center"} pt={2}>
        <Box width={{ xs: "100%", md: 900 }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default PageLayout;
